@if (deposit(); as deposit) {
  <div class="flex flex-col gap-3">
    <div class="flex flex-col gap-2 text-sm">
      @if (deposit.amountOverridden) {
        <div
          class="rounded border border-gray-200 bg-gray-50 p-2 text-xs text-gray-700"
        >
          The amount was set by staff when this appointment was booked, so the
          deposit settings will not explain it.
        </div>
      }

      @if (deposit.fallbackReason; as fallbackReason) {
        <div
          class="flex flex-col gap-1 rounded border border-amber-200 bg-amber-50 p-2 text-xs text-amber-900"
        >
          <span class="font-semibold">
            {{ depositCaptureStrategyFallbackLabels[fallbackReason] }}
          </span>
          <span>
            {{ depositCaptureStrategyFallbackDescriptions[fallbackReason] }}
          </span>
        </div>
      }

      <!--
        The attempt id rides on whichever row already exists rather than
        earning one of its own: it is reference data for support, not
        something reception reads. `paidAt` is the usual host, but an
        authorised hold carries an attempt with nothing paid yet, so the
        standalone row below still covers that case.
      -->
      <ng-template #copyPaymentAttempt let-paymentAttemptId="paymentAttemptId">
        <button
          mat-icon-button
          type="button"
          class="icon-xs shrink-0"
          [attr.aria-label]="'Copy payment attempt ID ' + paymentAttemptId"
          [matTooltip]="'Copy payment attempt ID: ' + paymentAttemptId"
          (click)="copyPaymentAttemptId(paymentAttemptId)"
        >
          <mat-icon class="icon-xs">content_copy</mat-icon>
        </button>
      </ng-template>

      @if (deposit.paidAt) {
        <div class="flex items-center justify-between gap-2">
          <span class="text-gray-600">Paid At:</span>
          <span class="flex items-center gap-1">
            <span class="font-semibold">{{
              deposit.paidAt | moment | amDateFormat: dateFormat
            }}</span>
            @if (deposit.paymentAttemptRef; as paymentAttemptRef) {
              <ng-container
                *ngTemplateOutlet="
                  copyPaymentAttempt;
                  context: { paymentAttemptId: paymentAttemptRef.id }
                "
              />
            }
          </span>
        </div>
      }

      @if (deposit.description) {
        <div class="flex flex-col gap-1">
          <span class="text-gray-600">Note:</span>
          <span class="text-sm">{{ deposit.description }}</span>
        </div>
      }

      @if (deposit.paymentAttemptRef; as paymentAttemptRef) {
        @if (!deposit.paidAt) {
          <div class="flex items-center justify-between gap-2">
            <span class="text-gray-600">Payment attempt</span>
            <ng-container
              *ngTemplateOutlet="
                copyPaymentAttempt;
                context: { paymentAttemptId: paymentAttemptRef.id }
              "
            />
          </div>
        }
      }

      @if (deposit.status === DepositStatus.Waived && deposit.waivedBy) {
        <div class="flex flex-col gap-2 border-t pt-2">
          <div class="flex justify-between">
            <span class="text-gray-600">Waived By:</span>
            <span class="font-semibold">{{ deposit.waivedBy.name }}</span>
          </div>
          @if (deposit.waiverReason) {
            <div class="flex flex-col gap-1">
              <span class="text-gray-600">Reason:</span>
              <span class="text-sm">{{ deposit.waiverReason }}</span>
            </div>
          }
        </div>
      }
    </div>

    <pr-deposit-actions
      hideChip
      labelledActions
      takeDepositAvailable
      reinstateAvailable
      [deposit]="deposit"
      [canOverrideDeposit]="canOverrideDeposit()"
      (waiveDeposit)="waiveDeposit.emit($event)"
      (unwaiveDeposit)="unwaiveDeposit.emit()"
      (takeDeposit)="takeDeposit.emit()"
    />
  </div>
}
